<!-- Футер -->
<footer>
  <div class="container">
    <div class="footer__wrapper">
      <div class="footer__img">
        <img src="assets/images/banner.svg" alt="banner" />
      </div>
      <div class="footer__links">
        <div class="footer__links__item">
          <div
            class="footer__links__title"
            [innerHTML]="'footer.menu' | translate"
          >
            <!-- Menu -->
          </div>
          <div class="footer__links__list">
            <a href="/" target="_blank" [innerHTML]="'footer.home' | translate">
              <!-- Home -->
            </a>
            <a
              href="/blog"
              target="_blank"
              [innerHTML]="'footer.blog' | translate"
            >
              <!-- Blog -->
            </a>
            <a
              href="/pricing"
              target="_blank"
              [innerHTML]="'footer.pricing' | translate"
            >
              <!-- Pricing -->
            </a>
          </div>
        </div>
        <div class="footer__links__item">
          <div
            class="footer__links__title"
            [innerHTML]="'footer.resources' | translate"
          >
            <!-- Resources -->
          </div>
          <div class="footer__links__list">
            <a
              href="/privacy_policy"
              target="_blank"
              [innerHTML]="'footer.privacy' | translate"
            >
              <!-- Privacy Policy -->
            </a>
            <a
              href="/terms_of_use"
              target="_blank"
              [innerHTML]="'footer.terms' | translate"
            >
              <!-- Terms of use -->
            </a>
            <a
              href="/faq"
              target="_blank"
              [innerHTML]="'footer.faq' | translate"
            >
              <!-- FAQ -->
            </a>
          </div>
        </div>
        <div class="footer__links__item">
          <div class="footer__links__list" style="padding-top: 48px"></div>
        </div>
      </div>
      <div class="footer__logo">
        <img
          style="padding-bottom: 15px"
          src="assets/images/removia-logo-white.svg"
          alt="logo"
        />
        <br />
        <div>
          <div>
            <span
              style="
                color: white;
                font-family: Manrope;
                font-weight: 800;
                font-size: 18px;
                line-height: 32px;
                letter-spacing: 0px;
                text-transform: uppercase;
              "
              [innerHTML]="'footer.contact' | translate"
            >
              <!-- Contact us -->
            </span>
            <br />
            <span
              style="
                color: white;
                font-family: Manrope;
                font-weight: 300;
                font-size: 18px;
                line-height: 22px;
                letter-spacing: -0.5px;
                text-decoration: underline;
                text-decoration-style: solid;
                text-decoration-offset: 0%;
                text-decoration-thickness: 0%;
              "
            >
              <a style="color: white" href="mailto:support@removia.io"
                >support@removia.io</a
              >
            </span>
          </div>
          <div>
            <p
              style="
                margin-top: 10px;
                padding-top: 10px;
                color: #ffffff;
                font-family: Manrope;
                font-weight: 300;
                font-size: 18px;
                line-height: 26px;
                letter-spacing: 0px;
              "
              [innerHTML]="'footer.company' | translate"
            >
              <!-- GotYourBack Technologies LTD
              <br>
              Ifigeneias 14, 3036 Limassol, Cyprus -->
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
